import {takeEvery} from 'redux-saga/effects'

import {
  ADD_SIBLINGS,
  ADD_STD_GENERAL_REMARKS,
  ADD_STD_SPORTS,
  ADD_STD_SPORTS_BY_ID,
  ADD_STD_SPORTS_REMARKS,
  ADD_STD_SUBJECTS_REMARKS,
  ADD_STUDENT,
  ASSIGN_EXAM,
  ASSIGN_HW,
  ASSIGN_HW_TEST_EXAM,
  ASSIGN_TEST,
  CREATE_PREVIOUS_CLASS_HISTORY,
  DELETE_UPLOADED_FILE,
  DEL_HW_TEST_EXAM,
  DEL_STD_EXAM,
  DEL_STD_GENERAL_REMARKS,
  DEL_STD_HOMEWORK,
  DEL_STD_SPORTS_REMARKS,
  DEL_STD_SUBJECTS_REMARKS,
  DEL_STD_TEST,
  EMAIL_LOGIN_DETAILS,
  GENERATE_STUDENT_LIST_REPORT,
  GENERATE_STUDENT_LOGIN_REPORT,
  GET_ACADEMIC_RECORD,
  GET_COUNSELLOR_MENTORS,
  GET_DONARS_LIST,
  GET_FILE_TYPES,
  GET_HW_TEST_EXAM,
  GET_MONTH_WISE_STUDENT_DROPOUT_PDF,
  GET_NEW_ADMISSION_STUDENT,
  GET_PARENT_BY_ID,
  GET_PREVIOUS_CLASS_HISTORY,
  GET_SIBLING_INFO,
  GET_STD_ACADEMIC_RECORD,
  GET_STD_ALL_SPORTS,
  GET_STD_EXAM,
  GET_STD_EXAM_ACADEMIC_RECORD,
  GET_STD_FEE_RECORD,
  GET_STD_GENERAL_REMARKS,
  GET_STD_HW,
  GET_STD_HW_ACADEMIC_RECORD,
  GET_STD_LATEST_STD_NO,
  GET_STD_PREV_EXAM_ACADEMIC_RECORD,
  GET_STD_PUBLIC_REMARKS,
  GET_STD_REMARKS_SPORTS,
  GET_STD_SUBJECTS,
  GET_STD_SUBJECTS_REMARKS,
  GET_STD_TEST,
  GET_STD_TEST_ACADEMIC_RECORD,
  GET_STD_UNEXAM,
  GET_STD_UNHW,
  GET_STD_UNTEST,
  GET_STD_USER_ID,
  GET_STUDENT_BY_ID,
  GET_STUDENT_DROPOUT_PDF,
  GET_STUDENT_LIST,
  GET_STUDENT_MINI_PROFILE,
  GET_STUDENT_SUBJECT_COMBINATION,
  GET_STUDENT_SUBJECT_EXAMS,
  GET_UPLOADED_FILE,
  INACTIVATE_STUDENT,
  SMS_LOGIN_DETAILS,
  UPDATE_STD_GENERAL_REMARKS,
  UPDATE_STD_SPORTS_REMARKS,
  UPDATE_STD_SUBJECTS_REMARKS,
  UPDATE_STUDENT,
  UPDATE_STUDENT_SUBJECT_COMBINATION,
  UPDATE_UPLOADED_FILE_TYPE,
  UPLOAD_FILE,
} from '../../../Actions/School/Student/ActionTypes/ApiActionTypes'
import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_STUDENT_LIST, fetchData)
  yield takeEvery(GET_STUDENT_MINI_PROFILE, fetchData)
  yield takeEvery(INACTIVATE_STUDENT, fetchData)
  yield takeEvery(GET_STD_ACADEMIC_RECORD, fetchData)
  yield takeEvery(UPDATE_STUDENT, fetchData)
  yield takeEvery(UPDATE_STUDENT_SUBJECT_COMBINATION, fetchData)
  yield takeEvery(ADD_STUDENT, fetchData)
  yield takeEvery(GET_STUDENT_BY_ID, fetchData)
  yield takeEvery(GET_STUDENT_SUBJECT_COMBINATION, fetchData)
  yield takeEvery(GET_PARENT_BY_ID, fetchData)
  yield takeEvery(GET_SIBLING_INFO, fetchData)
  yield takeEvery(GET_STD_FEE_RECORD, fetchData)
  yield takeEvery(GET_STD_REMARKS_SPORTS, fetchData)
  yield takeEvery(GET_STD_ALL_SPORTS, fetchData)
  yield takeEvery(GET_STD_GENERAL_REMARKS, fetchData)
  yield takeEvery(GET_STD_PUBLIC_REMARKS, fetchData)
  yield takeEvery(GET_STD_SUBJECTS_REMARKS, fetchData)
  yield takeEvery(UPDATE_STD_GENERAL_REMARKS, fetchData)
  yield takeEvery(UPDATE_STD_SUBJECTS_REMARKS, fetchData)
  yield takeEvery(UPDATE_STD_SPORTS_REMARKS, fetchData)
  yield takeEvery(GET_STD_USER_ID, fetchData)
  yield takeEvery(ADD_SIBLINGS, fetchData)
  yield takeEvery(ADD_STD_SPORTS, fetchData)
  yield takeEvery(ADD_STD_SPORTS_BY_ID, fetchData)
  yield takeEvery(GET_STD_HW, fetchData)
  yield takeEvery(GET_STD_EXAM, fetchData)
  yield takeEvery(GET_STD_TEST, fetchData)
  yield takeEvery(GET_STD_UNHW, fetchData)
  yield takeEvery(GET_STD_UNEXAM, fetchData)
  yield takeEvery(GET_STD_UNTEST, fetchData)
  yield takeEvery(ASSIGN_HW_TEST_EXAM, fetchData)
  yield takeEvery(ASSIGN_HW, fetchData)
  yield takeEvery(ASSIGN_TEST, fetchData)
  yield takeEvery(ASSIGN_EXAM, fetchData)
  yield takeEvery(GET_HW_TEST_EXAM, fetchData)
  yield takeEvery(DEL_HW_TEST_EXAM, fetchData)
  yield takeEvery(GET_STD_LATEST_STD_NO, fetchData)
  yield takeEvery(GET_STD_SUBJECTS, fetchData)
  yield takeEvery(ADD_STD_SUBJECTS_REMARKS, fetchData)
  yield takeEvery(ADD_STD_GENERAL_REMARKS, fetchData)
  yield takeEvery(DEL_STD_SUBJECTS_REMARKS, fetchData)
  yield takeEvery(DEL_STD_GENERAL_REMARKS, fetchData)
  yield takeEvery(DEL_STD_SPORTS_REMARKS, fetchData)
  yield takeEvery(GET_FILE_TYPES, fetchData)
  yield takeEvery(UPLOAD_FILE, fetchData)
  yield takeEvery(DEL_STD_HOMEWORK, fetchData)
  yield takeEvery(DEL_STD_TEST, fetchData)
  yield takeEvery(DEL_STD_EXAM, fetchData)
  yield takeEvery(GET_UPLOADED_FILE, fetchData)
  yield takeEvery(DELETE_UPLOADED_FILE, fetchData)
  yield takeEvery(UPDATE_UPLOADED_FILE_TYPE, fetchData)
  yield takeEvery(GET_STD_EXAM_ACADEMIC_RECORD, fetchData)
  yield takeEvery(GET_STD_TEST_ACADEMIC_RECORD, fetchData)
  yield takeEvery(GET_STD_HW_ACADEMIC_RECORD, fetchData)
  yield takeEvery(GET_PREVIOUS_CLASS_HISTORY, fetchData)
  yield takeEvery(CREATE_PREVIOUS_CLASS_HISTORY, fetchData)
  yield takeEvery(GET_STD_PREV_EXAM_ACADEMIC_RECORD, fetchData)
  yield takeEvery(ADD_STD_SPORTS_REMARKS, fetchData)
  yield takeEvery(GET_DONARS_LIST, fetchData)
  yield takeEvery(GET_NEW_ADMISSION_STUDENT, fetchData)
  yield takeEvery(GENERATE_STUDENT_LIST_REPORT, fetchData)
  yield takeEvery(GENERATE_STUDENT_LOGIN_REPORT, fetchData)
  yield takeEvery(GET_STUDENT_DROPOUT_PDF, fetchData)
  yield takeEvery(GET_MONTH_WISE_STUDENT_DROPOUT_PDF, fetchData)
  yield takeEvery(SMS_LOGIN_DETAILS, fetchData)
  yield takeEvery(EMAIL_LOGIN_DETAILS, fetchData)
  yield takeEvery(GET_ACADEMIC_RECORD, fetchData)
  yield takeEvery(GET_STUDENT_SUBJECT_EXAMS, fetchData)
  yield takeEvery(GET_COUNSELLOR_MENTORS, fetchData)
}

export default dataSaga
